import { Dialog } from '@ori-ui/components';
import { CircularProgress, useMediaQuery, useTheme } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

export const WizardLoader: FC = () => {
  const { getTestIdProps } = useTestId();
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('md'));

  return (
    <Dialog
      open
      hideCloseButton
      sx={{
        '& .MuiOriDialogBase-dialogGrid': { ...(isMobile && { top: '60px' }) },
        '& .MuiOriDialog-content': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
      {...getTestIdProps('wizard-loader')}
    >
      <CircularProgress />
    </Dialog>
  );
};
